
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locationSlug]/[merchantSlug]/[merchantId]/welcome",
      function () {
        return require("private-next-pages/[locationSlug]/[merchantSlug]/[merchantId]/welcome.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locationSlug]/[merchantSlug]/[merchantId]/welcome"])
      });
    }
  